module.exports = __webpack_public_path__ + "img/company-profile.2b0c731b.svg";